import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@softline/core';
import { Router } from '@angular/router';
import {
  BackNavigationService,
  HeaderComponent,
  SOFTLINE_FEATURE_TITLE,
  TitleStore,
} from '@softline/application';
import { TranslatePipe } from '@softline/ui-core';
import { type ProgressStep, ProgressStepsComponent } from '@softline/ui-core/progress';
import { SOFTLINE_FEATURE_LAGERKORREKTUR } from '../../lagerkorrektur.shared';
import { LagerkorrekturStore } from '../../store';
import {
  ArtikelMenge,
  ArtikelMengeAuswahlComponent,
  openSelectUnitDialog,
} from '@softapps/lager/core';
import { PageComponent, PageHeaderComponent } from '@softapps/core/pages';
@Component({
  selector: 'soft-artikel-auswahl',
  imports: [
    CommonModule,
    ProgressStepsComponent,
    ArtikelMengeAuswahlComponent,
    HeaderComponent,
    TranslatePipe,
    PageComponent,
    PageHeaderComponent,
  ],
  templateUrl: './artikel-auswahl.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./artikel-auswahl.page.css'],
})
export class ArtikelAuswahlPage implements OnInit {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly backNavigationService = inject(BackNavigationService);

  private readonly openSelectUnitDialog = openSelectUnitDialog();

  readonly steps: ProgressStep[] = [
    {
      header: '#LAGERKORREKTUR.PAGES.LAGERPLATZ_SCANNEN.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.LAGERPLATZ_SCANNEN.DESCRIPTION',
    },
    {
      header: '#LAGERKORREKTUR.PAGES.ARTIKEL_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.ARTIKEL_AUSWAHL.DESCRIPTION',
    },
    {
      header: '#LAGERKORREKTUR.PAGES.MENGEN_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.MENGEN_AUSWAHL.DESCRIPTION',
    },
    {
      header: '#LAGERKORREKTUR.PAGES.LAGERSYMBOL_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR.PAGES.LAGERSYMBOL_AUSWAHL.DESCRIPTION',
    },
  ];

  lagerplatz$ = this.store.observe(
    SOFTLINE_FEATURE_LAGERKORREKTUR,
    LagerkorrekturStore.getters.lagerplatz
  );

  constructor() {
    //
  }

  ngOnInit(): void {
    this.backNavigationService.set(this);
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      '#LAGERKORREKTUR.TITLE'
    );
  }

  ngOnDestroy() {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/lagerkorrektur']);
  }

  async onSelect(artikel: ArtikelMenge): Promise<void> {
    let selectedArtikel = { ...artikel };

    if (
      artikel.artikel.kzartikelart === 'DIF' ||
      artikel.artikel.kzartikelart === 'SDIF'
    ) {
      const result = await this.openSelectUnitDialog(artikel.einheitenAuswahl ?? []);
      if (!result || result === 'DISMISSED') return;
      selectedArtikel = {
        ...selectedArtikel,
        einheit: result.einheit,
        menge: result.menge,
      };
    }

    this.store.commit(
      SOFTLINE_FEATURE_LAGERKORREKTUR,
      LagerkorrekturStore.mutations.setArtikel,
      selectedArtikel
    );
    await this.router.navigate(['/lagerkorrektur', 'mengen-auswahl']);
  }
}
